export default __webpack_public_path__ + "660bf2a2acf1c47cdd4a1abf00eef3d5.png";